import React from 'react';
import { Link } from 'gatsby';
import isEmail from 'validator/es/lib/isEmail';

import Image from '../components/Image';
import ImageChart from '../components/ImageChart';
import ImageKeyFeaturesOne from '../components/ImageKeyFeaturesOne';
import ImageKeyFeaturesTwo from '../components/ImageKeyFeaturesTwo';
import ImageKeyFeaturesThree from '../components/ImageKeyFeaturesThree';
import ImageComplianceAutomationOne from '../components/ImageComplianceAutomationOne';
import ImageComplianceAutomationTwo from '../components/ImageComplianceAutomationTwo';
import ImageComplianceAutomationThree from '../components/ImageComplianceAutomationThree';
import SEO from '../components/Seo';

//fonts
import "@fontsource/alata";


import { Column, Container, Row } from '../elements/Grid';
import { BaseTitle, LgTitle, SmTitle, XsTitle } from '../elements/Titles';
import {
  BaseParagraph,
  LgParagraph,
  SmParagraph
} from '../elements/Paragraphs';
import { Button, ButtonOutline } from '../elements/Button';
import { Form } from '../elements/Form';
import { Wrapper } from '../elements/Wrappers';

import addToMailchimp from 'gatsby-plugin-mailchimp';
import './index.css';
class IndexPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      errors: {
        email: false
      },
      submitted: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.refOne = React.createRef();
    this.refTwo = React.createRef();
    this.refThree = React.createRef();
    this.refFour = React.createRef();
    this.scrollToRefFour = () => this.scrollToRef(this.refFour);
    this.scrollToRef = ref =>
      ref.current.scrollIntoView({ behavior: 'smooth' });

    this.props.passRefs([
      this.refOne,
      this.refTwo,
      this.refThree,
      this.refFour
    ]);
  }

  handleChange(e) {
    const { id, value } = e.target;

    this.setState({ [id]: e.target.value });
  }

  async handleSubmit(e) {
    e.preventDefault();

    const email = this.state.email;

    if (!isEmail(email)) {
      this.setState({ errors: { email: true } });

      return;
    }

    const result = await addToMailchimp(email);

    this.setState({
      email: '',
      errors: { email: false },
      submitted: true
    });
  }

  render() {
    return (
      <>
        <SEO title="Simplifying affiliate marketing for publishers" />
        <Container>
          <Row
            marginBottom="48"
            desktopMarginBottom="144"
            reverseOrderDesktop="true"
          >
            <Column width="1/2">
              <Image />
            </Column>
            <Column width="1/2">
              <LgTitle marginBottom="30">
                Simplifying affiliate marketing for publishers
              </LgTitle>
              <BaseParagraph marginBottom="44">
                Ribn<div className="registered">®</div> is leading-edge affiliate marketing technology for
                publishers — insightful reporting and analytics and advanced
                offer management.
              </BaseParagraph>
              <Button onClick={this.scrollToRefFour}>Book a Demo</Button>
            </Column>
          </Row>
          <Row
            id="why-ribn"
            justifyContent="center"
            marginBottom="48"
            desktopMarginBottom="144"
            textAlign="center"
            ref={this.refOne}
          >
            <Column width="1/2">
              <BaseTitle marginBottom="12">Why Ribn<div className="registered--lg">®</div> ?</BaseTitle>
              <SmTitle marginBottom="38">
                Ribn<div className="registered--md">®</div> takes the complication out of affiliate marketing.
              </SmTitle>
              <BaseParagraph>
                Affiliate marketing can be highly-involved, especially if you
                juggle multiple affiliate networks and develop direct
                partnerships. Ribn helps by sitting at the center of your
                affiliate marketing program and provides a single place to
                manage your offers and report revenue and performance in
                real-time.
              </BaseParagraph>
              <ImageChart />
              <ButtonOutline onClick={this.scrollToRefFour}>
                Book a Demo
              </ButtonOutline>
            </Column>
          </Row>
        </Container>
        <Wrapper
          marginBottom="48"
          desktopMarginBottom="144"
          textAlign="center"
          color="white"
          ref={this.refTwo}
        >
          <Container>
            <Row justifyContent="center" marginBottom="42">
              <Column>
                <BaseTitle  marginBottom="12">
                  Key Features
                </BaseTitle>
                <SmTitle >
                  Functionality that you didn’t know that you were missing.
                </SmTitle>
              </Column>
            </Row>
            <Row marginBottom="46" textAlign="left">
              <Column morePadding="true" width="1/3">
                <Row justifyContent="center">
                  <Column mobileWidth="1/2" width="1/2">
                    <ImageKeyFeaturesOne />
                  </Column>
                </Row>
                <XsTitle marginBottom="14">Real-time Reporting</XsTitle>
                <SmParagraph>
                  A single, unified place for all affiliate performance data
                  such as revenue, clicks and conversions. Pivot by metrics such
                  as device, geographic location and utm or unique tracking ID.
                  Performance anomaly detection out-of-the-box. Get alerted to
                  notable changes in performance of an offer.
                </SmParagraph>
              </Column>
              <Column morePadding="true" width="1/3">
                <Row justifyContent="center">
                  <Column mobileWidth="1/2" width="1/2">
                    <ImageKeyFeaturesTwo />
                  </Column>
                </Row>
                <XsTitle marginBottom="14">Offer Setup Wizard</XsTitle>
                <SmParagraph>
                  A guided step-by-step process for onboarding new affiliate
                  relationships that ensures your tracking is configured
                  correctly before you get started promoting an offer.
                </SmParagraph>
              </Column>
              <Column morePadding="true" width="1/3">
                <Row justifyContent="center">
                  <Column mobileWidth="1/2" width="1/2">
                    <ImageKeyFeaturesThree />
                  </Column>
                </Row>
                <XsTitle marginBottom="14">Offer Creatives</XsTitle>
                <SmParagraph marginBottom="16">
                  Create calls-to-action in Ribn, and place script tags directly
                  within paragraphs in any CMS. Ribn runs automated tests to
                  determine which calls-to-action work best.
                </SmParagraph>
                <SmParagraph>
                  If a campaign ends, or you land a better deal, swap affiliates
                  or offers in a single place. No more laborious page-by-page
                  editing.
                </SmParagraph>
              </Column>
            </Row>
            <Row justifyContent="center">
              <Column>
                <ButtonOutline onClick={this.scrollToRefFour}>
                  Book a Demo
                </ButtonOutline>
              </Column>
            </Row>
          </Container>
        </Wrapper>
        <Container ref={this.refThree}>
          <Row alignItems="center" marginBottom="48" desktopMarginBottom="144">
            <Column width="1/2">
              <BaseTitle color="black" marginBottom="36">
                Compliance Automation
              </BaseTitle>
              <LgParagraph>
                It’s difficult to keep track of the various rules and guidelines
                from your affiliates. Ribn automates compliance to ensure you’re
                always on-side.
              </LgParagraph>
            </Column>
            <Column width="1/2">
              <Row>
                <Column mobileWidth="1/2" width="1/4"><ImageComplianceAutomationOne /></Column>
                <Column width="3/4">
                  <XsTitle color="black" marginBottom="14">
                    Frequency Caps & Geo Limits
                  </XsTitle>
                  <SmParagraph desktopMarginBottom="40">
                    Offer only available in 23 states? CPC campaign limited to
                    50 clicks per day? Not a problem. Automatically redirect or
                    disable links based on click counts or geo.
                  </SmParagraph>
                </Column>
              </Row>
              <Row>
                <Column mobileWidth="1/2" width="1/4"><ImageComplianceAutomationTwo /></Column>
                <Column width="3/4">
                  <XsTitle color="black" marginBottom="14">
                    Bot Detection & Filtering
                  </XsTitle>
                  <SmParagraph desktopMarginBottom="40">
                    Automatically screen clicks for invalid traffic and protect
                    your downstream partners.
                  </SmParagraph>
                </Column>
              </Row>
              <Row>
                <Column mobileWidth="1/2" width="1/4"><ImageComplianceAutomationThree /></Column>
                <Column width="3/4">
                  <XsTitle color="black" marginBottom="14">
                    Compliance
                  </XsTitle>
                  <SmParagraph>
                    Automatically insert appropriate legal disclaimers. Send
                    appropriate tracking consent signals where required by your
                    affiliate partnerships.
                  </SmParagraph>
                </Column>
              </Row>
            </Column>
          </Row>
          <Row
            justifyContent="center"
            marginBottom="48"
            desktopMarginBottom="144"
            textAlign="center"
            ref={this.refFour}
          >
            <Column width="1/2">
              <BaseTitle marginBottom="12">Contact Us</BaseTitle>
              <SmTitle marginBottom="38">Get a personalized demo</SmTitle>
              <BaseParagraph marginBottom="38">
                Enter your email to arrange for a personal site review and demo
                by one of our industry experts.
              </BaseParagraph>
              {this.state.errors.email && (
                <BaseParagraph color="pink" marginBottom="14">
                  Please check your email
                </BaseParagraph>
              )}
              {this.state.errors.checkbox && (
                <BaseParagraph color="pink" marginBottom="14">
                  Please agree to the terms
                </BaseParagraph>
              )}
              {this.state.submitted && (
                <BaseParagraph color="green" marginBottom="14">
                  Thank you for subscribing!
                </BaseParagraph>
              )}
              <Form>
                <input
                  id="email"
                  name="email"
                  onChange={this.handleChange}
                  placeholder="Email"
                  type="email"
                  value={this.state.email}
                  autoComplete="off"
                />
              </Form>
              <ButtonOutline marginBottom="42" onClick={this.handleSubmit}>
                Book a Demo
              </ButtonOutline>
              <SmParagraph color="grey" marginBottom="16">
                By submitting this form, you agree that you’ve read and accept{' '}
                <a
                  href="https://www.wisepublishing.com/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Wise Publishing’s Privacy Policy
                </a>
                .
              </SmParagraph>
              <SmParagraph color="grey">
                I agree to receive communications from{' '}
                <a href="https://ribn.com/">ribn.com</a>. I may unsubscribe at
                any time.
              </SmParagraph>
            </Column>
          </Row>
        </Container>
      </>
    );
  }
}

export default IndexPage;
